import { render, staticRenderFns } from "./AppBreadcrumbs.vue?vue&type=template&id=7dabc46c"
import script from "./AppBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./AppBreadcrumbs.vue?vue&type=script&lang=ts"
import style0 from "./AppBreadcrumbs.vue?vue&type=style&index=0&id=7dabc46c&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppIcon: require('/builds/project/wyffest/frontend/components/app/AppIcon.vue').default})
